import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Paper,
  Box,
  Chip,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { handleTableData } from "./redux/syllabusSlice";
import { fetchSessionsThunk, fetchHolidaysThunk } from "../AcademicCalendar/redux/academicCalendarSlice";
import { submitSyllabusThunk } from "./redux/syllabusthunk";
import { useLocation, useNavigate } from "react-router-dom";
import {
  startTour,
  stopTour, setStepValid
} from "../../redux/globalJoyrideSlice";

import {
  adminSyllabusStage3TourSteps,
} from "../../tour/teacherPlanerTourSteps";


const SyllabusStage3 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { tableData } = useSelector((state) => state.syllabus);
  const { teacherPeriods } = useSelector((state) => state.myTimetable);
  const sessions = useSelector((state) => state.academicCalendar.sessions);
  const holidays = useSelector((state) => state.academicCalendar.holidays);
  const masterData = useSelector((state) => state.masterData);
  const userId = useSelector((state) => state.authSlice?.user?.id || state.authSlice?.user_id);
  const authData = useSelector((state) => state.authSlice);
  console.log("Auth State:", authData); // Look for 'id', 'user_id', or 'user.id' here
  console.log(masterData)
  console.log(userId)
  const schoolId = masterData?.school_id;
  const formData = location.state;
  const workingDaysPerWeek = Number(masterData?.workingDays) || 6;
  console.log(workingDaysPerWeek, "working days 50....")

  const [termStats, setTermStats] = useState({});
  const [revisionData, setRevisionData] = useState({
    revisionType: "",
    revisionStartDate: "",
    revisionEndDate: "",
  });

  console.log("complete term data 54 ............", termStats)

  useEffect(() => {
    if (!formData) {
      alert("Missing form data. Please upload again.");
      navigate("/adminUploadSyllabus");
    }
  }, [formData, navigate]);

  useEffect(() => {
    dispatch(fetchSessionsThunk());
  }, [dispatch]);


  useEffect(() => {
    // We need both to avoid the /undefined/ issue in the URL
    if (schoolId && userId) {
      dispatch(fetchHolidaysThunk({
        user_id: userId,
        school_id: schoolId
      }));
    }
  }, [dispatch, schoolId, userId]);

  const selectedClass = teacherPeriods.classes.find(
    (cls) => cls.class_id === Number(formData.selectedClass)
  );

  const filteredPeriods = teacherPeriods.periods.filter(
    (p) =>
      p.class_name === selectedClass?.class_name &&
      p.subject_id === Number(formData.selectedSubject)
  );

  useEffect(() => {
    if (tableData.length > 0) {
      dispatch(
        startTour({
          activeTour: "admin-syllabus-stage3",
          steps: adminSyllabusStage3TourSteps(),
        })
      );
    }
  }, [dispatch, tableData.length]);

  const calculateActualWorkingDays = (
    startDate,
    endDate,
    holidays = [],
    workingDaysPerWeek
  ) => {
    const holidayDates = new Set(
      holidays
        .filter((h) => h.start_date)
        .map((h) => moment(h.start_date).format("YYYY-MM-DD"))
    );

    console.log("Mapped Holiday Set (YYYY-MM-DD):", Array.from(holidayDates));

    let count = 0;
    let cursor = moment(startDate).clone();
    const end = moment(endDate);

    while (cursor.isSameOrBefore(end, "day")) {
      const dateStr = cursor.format("YYYY-MM-DD");
      const day = cursor.day(); // 0=Sunday, 6=Saturday

      const isWeekend =
        workingDaysPerWeek === 5
          ? day === 0 || day === 6   // Sat + Sun off
          : day === 0;               // Only Sunday off

      const isHoliday = holidayDates.has(dateStr);


      if (!isWeekend && !isHoliday) {
        count++;
      }

      cursor.add(1, "day");
    }

    return count;
  };
  // replace the existing function with this
  const countTermActualPeriods = (
    periods,
    termStart,
    termEnd,
    holidays = [],
    workingDaysPerWeek
  ) => {
    const holidayDates = new Set(
      holidays
        .filter((h) => h.start_date)
        .map((h) => moment(h.start_date).format("YYYY-MM-DD"))
    );

    let totalPeriods = 0;
    const cursor = termStart.clone();

    while (cursor.isSameOrBefore(termEnd, "day")) {
      const dateStr = cursor.format("YYYY-MM-DD");
      const day = cursor.day();
      const dayName = cursor.format("dddd");

      const isWeekend =
        workingDaysPerWeek === 5
          ? day === 0 || day === 6
          : day === 0;

      if (!isWeekend && !holidayDates.has(dateStr)) {
        const dayPeriods = periods.filter((p) => p.day === dayName);
        totalPeriods += dayPeriods.length;
      }

      cursor.add(1, "day");
    }

    return totalPeriods;
  };

  useEffect(() => {
    if (!sessions?.length || !teacherPeriods?.periods) return;
    console.log("Holidays from Redux:   168 ", holidays);
    const session = sessions[0];

    // 1. Use the specific term dates provided in your session JSON
    const t1Start = moment(session.term_one_start_date);
    const t1End = moment(session.term_one_end_date);
    const t2Start = moment(session.term_two_start_date);
    const t2End = moment(session.term_two_end_date);





    // 2. Calculate Working Days using your helper (excludes Sundays & Holidays)
    const term1Days = calculateActualWorkingDays(
      t1Start,
      t1End,
      holidays,
      workingDaysPerWeek
    );

    const term2Days = calculateActualWorkingDays(
      t2Start,
      t2End,
      holidays,
      workingDaysPerWeek
    );

    // 3. Calculate Actual Periods using your helper (excludes Sundays & Holidays)
    const term1Actual = countTermActualPeriods(
      filteredPeriods,
      t1Start,
      t1End,
      holidays,
      workingDaysPerWeek
    );

    const term2Actual = countTermActualPeriods(
      filteredPeriods,
      t2Start,
      t2End,
      holidays,
      workingDaysPerWeek
    );

    const term1Entered = tableData
      .filter((item) => item.term?.toLowerCase().includes("term1"))
      .reduce((acc, item) => acc + Number(item.numberofperiods || 0), 0);
    const term2Entered = tableData
      .filter((item) => item.term?.toLowerCase().includes("term2"))
      .reduce((acc, item) => acc + Number(item.numberofperiods || 0), 0);

    // 4. Set state with the corrected working dates and counts
    setTermStats({
      term1Start: t1Start.format("YYYY-MM-DD"),
      term1End: t1End.format("YYYY-MM-DD"),
      term2Start: t2Start.format("YYYY-MM-DD"),
      term2End: t2End.format("YYYY-MM-DD"),
      term1Days: term1Days, // Corrected working days
      term2Days: term2Days, // Corrected working days
      term1Actual,
      term2Actual,
      term1Entered,
      term2Entered,
    });
  }, [sessions, teacherPeriods, tableData, holidays]);

  const handleInputChange = (e, data) => {
    dispatch(
      handleTableData({
        name: e.target.name,
        value: e.target.value,
        id: data.id,
      })
    );
  };

  const handleBack = () => navigate("/uploadSyllabus", { state: formData });

  const handleRevisionTypeChange = (event) => {
    const { value } = event.target;

    setRevisionData((prev) => ({
      revisionType: value,
      revisionStartDate: value === "custom" ? prev.revisionStartDate : "",
      revisionEndDate: value === "custom" ? prev.revisionEndDate : "",
    }));
  };

  const handleRevisionDateChange = (event) => {
    const { name, value } = event.target;
    setRevisionData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const term1Exceeded = termStats.term1Entered > termStats.term1Actual;
    const term2Exceeded = termStats.term2Entered > termStats.term2Actual;

    if (term1Exceeded || term2Exceeded) {
      alert(
        "Submission blocked: One or more terms have exceeded the allowed number of periods."
      );
      return;
    }

    if (!revisionData.revisionType) {
      alert("Please select a revision type.");
      return;
    }

    if (revisionData.revisionType === "custom") {
      if (!revisionData.revisionStartDate || !revisionData.revisionEndDate) {
        alert("Please select both revision start and end dates.");
        return;
      }

      const revisionStart = moment(revisionData.revisionStartDate);
      const revisionEnd = moment(revisionData.revisionEndDate);

      if (revisionEnd.isBefore(revisionStart, "day")) {
        alert("Revision end date cannot be before the start date.");
        return;
      }

      const remainingPeriods =
        (termStats.term1Actual - termStats.term1Entered) +
        (termStats.term2Actual - termStats.term2Entered);

      if (remainingPeriods <= 0) {
        alert(
          "No remaining periods available for revision. Please reduce syllabus periods."
        );
        return;
      }

      const sessionEnd = moment(termStats.term2End);

      if (revisionStart.isAfter(sessionEnd) || revisionEnd.isAfter(sessionEnd)) {
        alert(
          `Revision must be within the academic session ending on ${termStats.term2End}`
        );
        return;
      }
    }

    const selectedClass = teacherPeriods.classes.find(
      (cls) => cls.class_id === Number(formData.selectedClass)
    );
    const selectedSubject = teacherPeriods.subjects.find(
      (s) => s.subject_id === Number(formData.selectedSubject)
    );

    const payload = {
      teacherId: teacherPeriods.teacher_id,
      classId: selectedClass.class_id,
      className: selectedClass.class_name,
      subjectId: selectedSubject.subject_id,
      subjectName: selectedSubject.subject_name,
      periods: filteredPeriods,
      syllabus: tableData,
      revisionType: revisionData.revisionType,
      ...(revisionData.revisionType === "custom"
        ? {
          revisionStartDate: revisionData.revisionStartDate,
          revisionEndDate: revisionData.revisionEndDate,
        }
        : {}),
    };

    try {
      const res = await dispatch(submitSyllabusThunk(payload)).unwrap();
      alert(res.message || "Submitted successfully");
      dispatch(stopTour());

      navigate("/allSyllabus", {
        state: { startTeacherTour: true },
      });
    } catch (err) {
      alert("Error: " + err.message);
    }
  };

  const sortedTableData = tableData
    .slice()
    .sort((a, b) => Number(a.termId || 0) - Number(b.termId || 0));

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        📄 Review Syllabus (Stage 2)
      </Typography>

      <Button variant="outlined" onClick={handleBack} sx={{ mb: 2 }}>
        ← Back
      </Button>

      {tableData.length > 0 ? (
        <Box sx={{ mt: 2 }}>
          <Box mt={3} p={2} bgcolor="#f9f9fc" borderRadius={2}>
            <Typography variant="h6" gutterBottom>
              📊 Term-wise Preview
            </Typography>
            <Box sx={{ overflowX: "auto" }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    {[
                      "Term",
                      "Start",
                      "End",
                      "Days",
                      "Actual Periods",
                      "Entered Periods",
                      "Remarks",
                      "Actions",
                    ].map((head, i) => (
                      <TableCell
                        key={i}
                        sx={{
                          backgroundColor: "#f0f0f0",
                          top: 0,
                          zIndex: 1,
                          position: "sticky",
                        }}
                      >
                        {head}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {["term1", "term2"].map((term) => {
                    const label = term === "term1" ? "Term 1" : "Term 2";
                    const actual = termStats[`${term}Actual`];
                    const entered = termStats[`${term}Entered`];
                    let remark = "";
                    if (entered < actual) {
                      remark = "You left some periods. Please add more.";
                    } else if (entered > actual) {
                      remark = "You have exceeded the expected periods.";
                    } else {
                      remark = "Perfect! Entered periods match the expected.";
                    }

                    return (
                      <TableRow key={term}>
                        <TableCell>{label}</TableCell>
                        <TableCell>{termStats[`${term}Start`]}</TableCell>
                        <TableCell>{termStats[`${term}End`]}</TableCell>
                        <TableCell>{termStats[`${term}Days`]}</TableCell>
                        <TableCell>{actual}</TableCell>
                        <TableCell>{entered}</TableCell>
                        <TableCell>
                          {entered > actual ? (
                            <Chip
                              label="Exceeded"
                              color="error"
                              variant="outlined"
                            />
                          ) : entered < actual ? (
                            <Chip
                              label="Incomplete"
                              color="warning"
                              variant="outlined"
                            />
                          ) : (
                            <Chip
                              label="Perfect"
                              color="success"
                              variant="outlined"
                            />
                          )}
                        </TableCell>

                        <TableCell>
                          {entered > actual ? (
                            <Chip label="✖" color="error" />
                          ) : entered < actual ? (
                            <Chip label="⚠" color="warning" />
                          ) : (
                            <Chip label="✔" color="success" />
                          )}
                          <Chip
                            label="👁️"
                            color="info"
                            clickable
                            onClick={() => {
                              const chapterList = tableData.filter(
                                (item) => item.term?.toLowerCase() === term
                              );

                              const entered = termStats[`${term}Entered`] || 0;
                              const actual = termStats[`${term}Actual`] || 0;
                              const remaining = actual - entered;

                              let chapterDetails = chapterList
                                .map(
                                  (item) =>
                                    `• ${item.chapter}: ${item.numberofperiods || 0
                                    }`
                                )
                                .join("\n");

                              const message = `
📘 ${term === "term1" ? "Term 1" : "Term 2"} Details

Chapters and Entered Periods:
${chapterDetails || "No chapters added."}

Total Entered: ${entered}
Remaining: ${remaining >= 0 ? remaining : 0}
    `;

                              alert(message);
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Box>
          <Paper elevation={2} sx={{ p: 1 }}>
            <form onSubmit={handleSubmit}>
              <Box
                sx={{
                  maxHeight: 400,
                  overflow: "auto",
                  border: "1px solid #ccc",
                  borderRadius: 1,
                }}
              >
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ backgroundColor: "#f0f0f0", p: "6px" }}>
                        S.No
                      </TableCell>
                      <TableCell sx={{ backgroundColor: "#f0f0f0", p: "6px" }}>
                        Chapter Name
                      </TableCell>
                      <TableCell sx={{ backgroundColor: "#f0f0f0", p: "6px" }}>
                        Term
                      </TableCell>
                      <TableCell sx={{ backgroundColor: "#f0f0f0", p: "6px" }}>
                        No of Periods
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody
                    data-tour="syllabus-periods-input">
                    {sortedTableData.map((data, i) => (
                      <TableRow key={i}>
                        <TableCell sx={{ p: "6px" }}>{i + 1}</TableCell>
                        <TableCell sx={{ p: "6px" }}>{data.chapter}</TableCell>
                        <TableCell sx={{ p: "6px" }}>{data.term}</TableCell>
                        <TableCell sx={{ p: "6px" }}>
                          <TextField
                            name="numberofperiods"
                            type="number"
                            size="small"
                            required
                            fullWidth
                            value={data.numberofperiods || ""}
                            onChange={(e) => {
                              handleInputChange(e, data)
                              dispatch(setStepValid(true))
                            }
                            }
                            sx={{
                              width: "60px",
                              "& input": {
                                p: "4px 8px",
                                fontSize: "0.875rem",
                              },
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>

              <Box
                sx={{
                  mt: 3,
                  p: 2,
                  border: "1px solid #e0e0e0",
                  borderRadius: 1,
                  backgroundColor: "#fafafa",
                }}
              >
                <FormControl component="fieldset">
                  <FormLabel component="legend">Revision</FormLabel>
                  <RadioGroup
                    row
                    name="revisionType"
                    value={revisionData.revisionType}
                    onChange={handleRevisionTypeChange}
                  >
                    <FormControlLabel
                      value="middle"
                      control={<Radio />}
                      label="Middle"
                    />
                    <FormControlLabel
                      value="end"
                      control={<Radio />}
                      label="End"
                    />
                    {/* <FormControlLabel
                      value="custom"
                      control={<Radio />}
                      label="Custom"
                    /> */}
                  </RadioGroup>
                </FormControl>

                {revisionData.revisionType === "custom" && (
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      mt: 2,
                      flexWrap: "wrap",
                    }}
                  >
                    <TextField
                      label="Revision Start Date"
                      name="revisionStartDate"
                      type="date"
                      size="small"
                      required
                      value={revisionData.revisionStartDate}
                      onChange={handleRevisionDateChange}
                      InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                      label="Revision End Date"
                      name="revisionEndDate"
                      type="date"
                      size="small"
                      required
                      value={revisionData.revisionEndDate}
                      onChange={handleRevisionDateChange}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Box>
                )}
              </Box>

              <Box textAlign="center" mt={2}>
                <Button
                  data-tour="syllabus-submit-btn"
                  variant="contained" color="primary" type="submit">
                  Submit
                </Button>
              </Box>
            </form>

            {/* Term-wise Summary Table */}
          </Paper>
        </Box>
      ) : (
        <Typography variant="body1" color="textSecondary">
          No Data Found
        </Typography>
      )}
    </Container>
  );
};

export default SyllabusStage3;